import { Label, RadioGroupItem, Stack, Tooltip, TooltipArrow, TooltipContent, TooltipTrigger } from 'component-library';

export const RadioItem = ({
  disabled,
  label,
  isChecked,
  value,
  tooltip,
  dataTestid,
}: {
  disabled?: boolean;
  label: string;
  isChecked: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  tooltip?: string;
  dataTestid?: string;
}) => {
  return (
    <Stack className='p-2' spacing={2} data-testid={dataTestid}>
      <Stack direction='row' spacing={2} centerMain>
        <RadioGroupItem value={value} disabled={disabled} checked={isChecked} id={value} />
        <Label className='typography-body1' htmlFor={value}>
          {label}
          {tooltip && (
            <Tooltip>
              <TooltipTrigger>
                <i className='ri-information-line ml-2' />
              </TooltipTrigger>
              <TooltipContent side='top'>
                {tooltip}
                <TooltipArrow />
              </TooltipContent>
            </Tooltip>
          )}
        </Label>
      </Stack>
    </Stack>
  );
};
